import Vue from 'vue';
import Vuex from 'vuex';
import {my} from './api/Cache';

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        site_title: 'ATLAS 寰图体育管理系统',
        my: null,
        isCollapse: true,
        count: null,
    },
    mutations: {
        setCount(state, count) {
            state.count = count;
        },
        setMy(state, my) {
            state.my = my;
        },
        setCollapse(state, isCollapse) {
            state.isCollapse = isCollapse;
        },
    },
    actions: {
        getMy({ commit }) {
            return my(commit);
        },
    },
});
